const createDropdownList = (elContainer, props) => {
  const {
    elType,
    childElType,
    elClass,
    elDataAtr,
    min = 1990,
    max = 2030,
  } = props

  for (let i = min; i <= max; i++) {
    const childElement = document.createElement(childElType)
    if (elClass) {
      childElement.classList.add(elClass)
    }
    if (elType === 'ul') {
      childElement.dataset.year = elDataAtr
    }
    childElement.textContent = i

    elContainer.appendChild(childElement)
  }
}

const createList = container => {
  const minYear = container.querySelector('[data-year-min]')
  const maxYear = container.querySelector('[data-year-max]')

  const minYearList = container.querySelector('[data-min-year-container]')
  const maxYearList = container.querySelector('[data-max-year-container]')
  const minYearListSelect = container.querySelector(
    '[data-min-year-container-mobile]'
  )
  const maxYearListSelect = container.querySelector(
    '[data-max-year-container-mobile]'
  )

  if (!minYear || !maxYear) return

  if (+minYear.dataset.yearMin === 0) {
    minYear.dataset.yearMin = 1990
  }
  if (+maxYear.dataset.yearMax === 0) {
    maxYear.dataset.yearMax = 2030
  }

  createDropdownList(minYearList, {
    elType: 'ul',
    childElType: 'li',
    elClass: 'dropdown__item',
    elDataAtr: 'min',
    min: +minYear.dataset.yearMin,
    max: +maxYear.dataset.yearMax,
  })
  createDropdownList(minYearListSelect, {
    name: 'min-year',
    elType: 'select',
    childElType: 'option',
    elDataAtr: 'min',
    min: +minYear.dataset.yearMin,
    max: +maxYear.dataset.yearMax,
  })
  createDropdownList(maxYearList, {
    elType: 'ul',
    childElType: 'li',
    elClass: 'dropdown__item',
    elDataAtr: 'max',
    min: +minYear.dataset.yearMin,
    max: +maxYear.dataset.yearMax,
  })
  createDropdownList(maxYearListSelect, {
    name: 'max-year',
    elType: 'select',
    childElType: 'option',
    elDataAtr: 'max',
    min: +minYear.dataset.yearMin,
    max: +maxYear.dataset.yearMax,
  })
}

export default createList
